import React, { useEffect, useState } from 'react';
import {  useDispatch } from 'react-redux';
import { Button,  Typography } from '@mui/material';
import Tags from '../../../shared/AutoCompleteChipsGroups';
import {  setSnackBar } from '../../../store/Slice';
import { getGroups, addUsrGroup } from '../../../services/pbiCracksApi';

const UserAddGr = (props) => {
  const [tagsValue, setTagsValue] = useState([]);
  const [groups, setGroups] = useState([]);
 
  const dispatch = useDispatch();
  const handleTagsChange = newValue => {
    setTagsValue(newValue);
  };

  

  useEffect(() => {
    const fetchGraups = async () => {
      try {
        const fetchedGroups = await getGroups();
        setGroups(fetchedGroups);
      } catch (error) {
       
      }
    };
    fetchGraups(); 
  }, []);

  const handleAddGroups = async () => {
    if(validate()){

      try {
        tagsValue.forEach(group => {
          addUsrGroup( [props.id], group.ID)
        })
        props.setUpdate(true);
        changeSnackbar('success', 'Agregado correctamente')
        props.handleCloseModal()
        
      } catch (error) {
        changeSnackbar('error', 'Error al agregar grupos')
        
      }
    }
  };

  const changeSnackbar = (estado, mensaje) => {

    const payload = {
      snackBar: {
        open: true,
        state: estado,
        msg: mensaje
      }
    }

    dispatch(setSnackBar(payload));
  };

  const validate = () => {

    if(Object.keys(tagsValue ).length === 0){
      changeSnackbar('error', 'Seleccione grupos para agregar')
      return false
    }

      return true

  }


  return (
    <>
     <Typography sx={{ fontSize: 'xx-Large', fontWeight: '600', color: '#f98727', width: '100%', textAlign: 'center' }}>Agregar grupos</Typography>
      
      <Tags value={tagsValue} onChange={handleTagsChange} groups={groups} /> 
      <div style={{
        display: 'flex',
        justifyContent: 'end',
        padding: '1vw'
      }}>

      <Button sx={{ marginTop: '3vh'}} variant="contained" onClick={handleAddGroups}>Agregar</Button>
      </div>
    </>
  );
};

export default UserAddGr
